import styled from "styled-components";
import {
  SPIN_BONUS_IMG,
  BONUS_IMG,
  RefreshOutlined,
} from "@assets";
import {
  REJECTED_SK,
  REQUESTED_SK,
} from '@constants';

export const RootContainer = styled.div`
position: relative;
height: 100vh;
overflow: hidden;
`;

export const RefreshIcon = styled(RefreshOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const TopContainer = styled.div`
position: relative;
`;

export const TopWrapper = styled.div`
width: 100%;
padding: 13px 0;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 4px;
background: linear-gradient(90deg, #2D0059 0%, #4D0395 100%);
position: relative;

svg {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const TopTitle = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #fff;
`;

export const BalanceText = styled.div`
font-size: 26px;
font-style: normal;
font-weight: 600;
line-height: 1.5;
color: #fff;
`;

export const LabelsContainer = styled.div`
padding: 8px 0;
background: #F8EEFF;
display: flex;
align-items: center;
justify-content: center;
`;

export const LightText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #000000;
`;

export const LightTextLabel = styled(LightText)`
color: #9B92BB;;
`;

export const LabelWrapper = styled.div`
flex: 1;
text-align: center;

:first-child {
  border-right: 1px solid #E5E0F5;
}
`;

export const ActionButton = styled.div`
flex: 1;
padding: 14px 0;
display: flex;
justify-content: center;
align-items: center;
gap: 4px;

background-color: ${props => props.theme.buttonColor};
border-radius: 12px;
cursor: pointer;
`;

export const ActionLabel = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #fff;
`;

export const ActionsWrapper = styled.div`
width: 100%;
margin-top: 12px;
margin-bottom: 16px;
display: flex;
gap: 16px;
align-items: center;
justify-content: center;

>div {
    :first-child {
        margin-inline-start: 16px;
    }
    :last-child {
        margin-inline-end: 16px;
    }
}
`;

export const SeeAllText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #8A01CC;
cursor: pointer;
`;

export const ListTitle = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #303030;
`;

export const EmptyText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;

export const ListContainer = styled.div`
height: calc(100vh - 316px);
overflow-y: auto;

.loader {
    height: calc(100vh - 316px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-box {
    height: calc(100vh - 316px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 24px;
        color: #808080;
    }
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 16px 12px;
  margin-bottom: 1px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background-color: #F8EEFF;

  @media screen and (max-width: 375px) {
      padding: 16px 8px;
      gap: 6px;
    }

  @media screen and (max-width: 305px) {
    padding: 12px 6px;
    }
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 5px;
`

export const ItemImage = styled.img.attrs({
  alt: 'img'
})`
width: 56px;
height: 56px;
border-radius: 12px;
object-fit: cover;

@media screen and (max-width: 350px) {
width: 40px;
height: 40px;
}
`;

export const InfoWrapper = styled.div`
flex: 1;
display: flex;
width: 100%;

> :nth-child(1) {
  flex: 1;
}
`;

export const Wrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
`;

export const ItemText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
text-transform: capitalize;
color: #49028E;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #9B92BB;

@media screen and (max-width: 425px) {
    font-size: 12px;
  }

@media screen and (max-width: 375px) {
    font-size: 11px;
  }

@media screen and (max-width: 305px) {
    font-size: 10px;
  }
`;

export const AmountText = styled.div`
white-space: nowrap;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: normal;
color: #49028E;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const StatusText = styled.div`
white-space: nowrap;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
text-transform: capitalize;
color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#000000"
      : props.status === REJECTED_SK
        ? "#ffffff"
        : "#ffffff"};
background-color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#ffffff"
      : props.status === REJECTED_SK
        ? "#FE0C37"
        : "#23AB41"};
border-radius: 27px;
padding: 0 8px;
display: flex;
align-items: center;
justify-content: center;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const BonusStatusText = styled(StatusText)`
text-transform: none;
width: auto;
color: ${(props) => props.status === 'Used' ? "#ffffff" : "#ffffff"};
background-color: ${(props) => props.status === 'Used' ? "#FE0C37" : "#23AB41"};
`;

export const ImageWrapper = styled.div`
width: 42px;
height: 42px;
padding: 7px;
border-radius: 12px;
object-fit: cover;
background-color: #ffffff;
display: flex;
align-items: center;
justify-content: center;

@media screen and (max-width: 350px) {
width: 28px;
height: 28px;
padding: 6px;
}
`;

const Image = styled.img.attrs({
  alt: "img",
})`
width: 100%;
object-fit: contain;
align-self: center;
`;

export const SpinImage = styled(Image).attrs({
  src: SPIN_BONUS_IMG,
})``;

export const BonusImage = styled(Image).attrs({
  src: BONUS_IMG,
})``;

export const ExpiredLabel = styled.span`
white-space: nowrap;
color: #FE0C37;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;

  @media screen and (max-width: 390px) {
    font-size: 13px;
  }

@media screen and (max-width: 425px) {
    font-size: 12px;
  }

@media screen and (max-width: 375px) {
    font-size: 11px;
  }

@media screen and (max-width: 305px) {
    font-size: 10px;
  }
`;

export const ExpiredText = styled(ExpiredLabel)`
color: #9B92BB;
`;

export const ListRootContainer = styled.div`
height: calc(100vh - 340px);
position: relative;
`;

export const ListTitleWrapper = styled.div`
display: flex;
justify-content: space-between;
padding: 0 16px 6px 16px;

@media screen and (max-width: 375px) {
  padding: 0 12px 6px 12px;
}

  @media screen and (max-width: 305px) {
    padding: 0 8px 6px 8px;
    }
`;